import { render, staticRenderFns } from "./AdminUserDisplay.vue?vue&type=template&id=20bd6e82&scoped=true&"
import script from "./AdminUserDisplay.vue?vue&type=script&lang=js&"
export * from "./AdminUserDisplay.vue?vue&type=script&lang=js&"
import style0 from "./AdminUserDisplay.vue?vue&type=style&index=0&id=20bd6e82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bd6e82",
  null
  
)

export default component.exports